let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZinD"), load("6gqpV"), load("fZyYv")]).then(() => parcelRequire('7PP2u'));